import React from 'react';
import { Box } from '@chakra-ui/core';
import { useStoreState } from '../../../../../models/hooks';
import { SelectedPositionView } from './SelectedPositionView';

function PositionRecruiterViewComponent() {
  const { selectedPosition } = useStoreState((state) => state.moniterByRecruiters);
  if (!selectedPosition) return null;
  return (
    <Box flexGrow={1} sx={{ minHeight: 0, height: '-webkit-fill-available', maxWidth: '450px' }}>
      <SelectedPositionView position={selectedPosition} />
    </Box>
  );
}

export const PositionRecruiterView = React.memo(PositionRecruiterViewComponent);
